/**
 * Image Zoom Form (V2)
 * Holds DOM references/state only.
 */

import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

export class ImageZoomForm extends FormBase {
    public root: HTMLElement;

    public source: Element | null;

    public target: Element | null;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
        this.source = this.queryElement(root, "[data-image-zoom-source]", HTMLElement);
        this.target = this.queryElement(root, "[data-image-zoom-target]", HTMLElement);
    }

    public static getRoots(scope: Document | HTMLElement = document): HTMLElement[] {
        const form = new ImageZoomForm(scope instanceof HTMLElement ? scope : document.body);
        const roots: HTMLElement[] = [];
        if (scope instanceof HTMLElement && scope.matches("[data-image-zoom-root]")) {
            roots.push(scope);
        }
        form.queryElements(scope, "[data-image-zoom-root]", HTMLElement).forEach((root) => {
            if (!roots.includes(root)) {
                roots.push(root);
            }
        });
        return roots;
    }

    public isInitialized(): boolean {
        return this.root.dataset.imageZoomInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.imageZoomInit = "1";
    }

    public getSource(): HTMLElement | null {
        return this.source instanceof HTMLElement ? this.source : null;
    }

    public getTarget(): HTMLElement | null {
        return this.target instanceof HTMLElement ? this.target : null;
    }

    public getPanel(): HTMLElement | null {
        return this.queryElement(this.root, "[data-image-zoom-panel]", HTMLElement);
    }

    public getModalBody(): HTMLElement | null {
        return this.closest(this.root, `[data-role="${Roles.ELEMENT_MODAL_BODY}"], .element-modal-body`, HTMLElement);
    }
}
